import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { changeHighlight } from "ducks/ui/actions";

const propTypes = {
  children: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  changeHighlight: PropTypes.func.isRequired,
  highlighted: PropTypes.bool.isRequired,
};

/**
 * Component used for highlight latest used row.
 * Dispatches new highlighted to store and returns active highlight.
 */
class RowHighlighter extends React.Component {
  handleClick = () => {
    const { id, name, changeHighlight, highlighted } = this.props;
    if (id === highlighted) return;
    changeHighlight({ name, id });
  };
  render() {
    return (
      <div onClick={this.handleClick}>
        {this.props.children({
          highlighted: this.props.highlighted,
          highlight: this.handleClick,
        })}
      </div>
    );
  }
}

const mapState = (state, props) => ({
  highlighted: state.ui.highlights[props.name] === props.id,
});

RowHighlighter.propTypes = propTypes;
export default connect(mapState, { changeHighlight })(RowHighlighter);



// WEBPACK FOOTER //
// ./src/components/ui/RowHighlighter.jsx